<template>
  <div class="main-container">
    <!-- Navbar section -->
    <Navbar />

    <!-- Home Page image loading section -->
    <HomeHeader />
    <div class="padding-branding" style="">
      <!-- About Section -->
      <AboutUs />
    </div>

    <!-- Services section -->
    <div class="" id="services">
      <Services />
    </div>

    <!-- Map section -->

    <!-- newsletter section -->
    <Newsletter />

    <!-- footer section -->
    <Footer />
  </div>
</template>

<script>
import Navbar from "../components/Navbar";
import AboutUs from "../components/AboutUs";
import HomeHeader from "../components/HomeHeader.vue";
import Services from "../components/Services";
import Newsletter from "../components/Newsletter";
import Footer from "../components/Footer";

export default {
  name: "app",
  components: {
    Navbar,
    HomeHeader,
    AboutUs,
    Services,
    Newsletter,
    Footer,
  },

  // method for translation to arabic and english
  methods: {
    i18n(key, args) {
      return this.$t(key, args);
    },
  },
  computed: {
    language() {
      return this.$i18n.locale;
    },
  },
  created() {
    document.title = this.i18n("app.title") + " | " + this.i18n("app.home");
  },
  watch: {
    language() {
      document.title = this.i18n("app.title") + " | " + this.i18n("app.home");
    },
  },
  mounted() {
    var lang = this.$route.params.lang;
    if (!lang) {
      lang = localStorage.getItem("language") || "ar";
      var route = `/${lang}${this.$route.fullPath.substring(3)}`;
      this.$router.push(route);
    } else if (lang != "ar" && lang != "en") {
      this.$router.push({ name: "NotFound" });
    }

    var langInStorage =
      this.$route.params.lang || localStorage.getItem("language");
    this.$i18n.locale = lang;
    if (langInStorage == "ar") {
      document.body.setAttribute("dir", "rtl");
    }
  },
};
</script>

<style lang="scss"></style>
